var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgHeadphones = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-4968e049-d0ba-41bb-a1a7-4490ff2e6565",
    viewBox: "0 0 15 15",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m14.96,7.79c0-1.01-.2-1.98-.59-2.9-.38-.89-.91-1.69-1.6-2.37-.68-.68-1.48-1.22-2.37-1.6-.92-.39-1.9-.59-2.9-.59s-1.98.2-2.9.59c-.89.38-1.69.91-2.37,1.6-.68.68-1.22,1.48-1.6,2.37C.24,5.81.04,6.78.04,7.79c0,.74.11,1.47.32,2.17v3.27c0,.31.25.56.56.56h.66c.08,0,.16-.02.23-.05v.34c0,.41.33.74.74.74h.67c.41,0,.74-.33.74-.74v-5.41c0-.41-.33-.74-.74-.74h-.67c-.41,0-.74.33-.74.74v.34c-.07-.03-.15-.05-.23-.05h-.34c-.07-.38-.11-.78-.11-1.17C1.14,4.28,3.99,1.43,7.5,1.43s6.36,2.85,6.36,6.36c0,.4-.04.79-.11,1.17h-.34c-.08,0-.16.02-.23.05v-.34c0-.41-.33-.74-.74-.74h-.67c-.41,0-.74.33-.74.74v5.41c0,.41.33.74.74.74h.67c.41,0,.74-.33.74-.74v-.34c.07.03.15.05.23.05h.66c.31,0,.56-.25.56-.56v-3.27c.21-.7.32-1.43.32-2.17Z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgHeadphones, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/headphones.9f19e5ff.svg";
export { ForwardRef as ReactComponent };